import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://apis.bakumia.pk/backend-api",
});

export default apiClient;

export const IMAGE_BASE_URL = "https://apis.bakumia.pk/public";
